import { useEffect, useContext } from "react";
import { Modal, Button, Row, Col } from "antd";
import Images from "./../../../../asset/exportImages";
import { GlobalState } from "./../../../../context/globalState";

function MDDeleteAlert({ handelCanCel, nameDelete }) {
  const { isMobile } = useContext(GlobalState);

  useEffect(() => {

  }, []);

  return (
    <>
      <Modal
        footer={false}
        open={true}
        centered={false}
        closable={false}
        // onCancel={handelCanCel}
        style={{ maxWidth: isMobile ? "" : 325 }}
        
      >
        <Row gutter={[15, 15]}>
          <Col xs={24}>
            <div style={{ textAlign: 'center' }}>
              <img width={"60px"} height={"60px"} src={Images.ICWarning} />
            </div>
          </Col>
          <Col xs={24}>
            <div style={{ fontSize: 15, color: '#343A40' }}>
              Thông báo người bảo hiểm sau không được tham gia gói bảo hiểm này:
            </div>
          </Col>
          <Col xs={24}>
             {
              nameDelete.map((item,index)=>(
                <div>
                  <span>{index+1}. </span>
                  <span style={{textTransform:'capitalize'}}>{item}</span>
                </div>
              ))
             }
          </Col>
          <Col xs={24}>
            <div style={{ fontSize: 15, color: '#343A40' }}>
              <b>Hệ thống sẽ tự động xóa ra khỏi danh sách người được bảo hiểm.</b>
            </div>
          </Col>
          <Col xs={24}>
            <Button
              onClick={() => handelCanCel()}
              style={{ backgroundColor: '#F0F2F5', height: 44, color: '#343A40', width: '100%', boxShadow: 'none', fontWeight: 500, borderRadius: 8, border: '0.5px solid #D2D2D2'}}
              type="primary">
              Thoát
            </Button>
          </Col>
        </Row>
      </Modal >
    </>
  );
}

export default MDDeleteAlert;
